module.exports = __webpack_public_path__ + "d664201f/img/upload-icon.9179ae4e.svg";